export const isValidEmail = (value: string) => {
    value = value.trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailRegex.test(value)) {
        return true; // Validação de e-mail
    }

    return false;
};